import { render, staticRenderFns } from "./AssignClient.vue?vue&type=template&id=72ca2775"
import script from "./AssignClient.vue?vue&type=script&lang=js"
export * from "./AssignClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports